import { BED_COUNT, TRUSTPILOT_RATING } from "constants/configConstants";
//

type Insight = {
  title: any;
  subtitle: string;
  icon: string;
};

export const INSIGHTS_DATA: Insight[] = [
  {
    title: BED_COUNT,
    subtitle: "Beds",
    icon: "homepage-beds-2",
  },
  {
    title: "800+",
    subtitle: "Universities",
    icon: "homepage-universities-2",
  },
  {
    title: "250+",
    subtitle: "Global Cities",
    icon: "homepage-cities-2",
  },
  {
    title: `${TRUSTPILOT_RATING}/5`,
    subtitle: "Trust Rating",
    icon: "homepage-review",
  },
];

export const INSIGHTS_DATA_DESKTOP: Insight[] = [
  {
    title: "home.collectionrailsgroup.insights.data.bedstitle",
    subtitle: "home.collectionrailsgroup.insights.data.bedssubtitle",
    icon: "homepage-beds",
  },
  {
    title: "home.collectionrailsgroup.insights.data.universitiestitle",
    subtitle: "home.collectionrailsgroup.insights.data.universitiessubtitle",
    icon: "homepage-universities",
  },
  {
    title: "home.collectionrailsgroup.insights.data.citiestitle",
    subtitle: "home.collectionrailsgroup.insights.data.citiessubtitle",
    icon: "homepage-cities",
  },
  {
    title: [
      "home.collectionrailsgroup.insights.data.trustpilottitle",
      { RATING: TRUSTPILOT_RATING },
    ],
    subtitle: "home.collectionrailsgroup.insights.data.trustpilotsubtitle",
    icon: "trustpilot",
  },
];
